import DRAMAS from "./dramas";

/**
 * FlowCarousel 的 items。只给 src / alt：海报自带标题，再传 title、subtitle
 * 会多叠一层 DOM 文案，和图里的字重影。
 *
 * 图片 require 必须留在这里 —— dramas.js 要被 vue.config.js 在 Node 里 require，
 * 不能出现 webpack 才认的路径别名和 .webp。
 */
export const carouselItems = DRAMAS.map(d => ({
  src: require(`@/assets/images/carousel/${d.file}.webp`),
  alt: `${d.name}｜${d.desc}`
}));

export default carouselItems;
